<template>
  <form-wrapper>
    <b-form @submit="onSubmit">
      <b-form-group>
        <label for="email-input">User ID</label>
        <input
          :value="client.id"
          disabled
          class="form-control"
          type="text"/>
      </b-form-group>

      <b-form-group>
        <label for="email-input">Email address</label>
        <input
          v-validate="'email'"
          id="email-input"
          :disabled="saving"
          :class="{ 'is-invalid' : errors.has('email') || apiErrors.email.length }"
          :value="fields.email === null ? client.email : fields.email"
          class="form-control"
          type="text"
          name="email"
          @input="setEmail"/>
        <validation-errors :validation-errors="[errors.first('email')]"/>
        <validation-errors v-if="!errors.has('email')" :validation-errors="apiErrors.email"/>
      </b-form-group>

      <b-tooltip target="email-input" triggers="focus" placement="right">
        Changing your email requires you to confirm your new address.
      </b-tooltip>

      <b-form-group>
        <label for="name-input">Full Name</label>
        <input
          v-validate="'alpha_spaces'"
          id="name-input"
          :disabled="saving"
          :class="{ 'is-invalid' : errors.has('name') || apiErrors.name.length}"
          :value="fields.name === null ? client.name : fields.name"
          class="form-control"
          type="text"
          name="name"
          @input="setName"/>
        <validation-errors :validation-errors="[errors.first('name')]"/>
        <validation-errors v-if="!errors.has('name')" :validation-errors="apiErrors.name"/>
      </b-form-group>

      <b-form-group>
        <label for="password-input">Password</label>
        <input
          v-validate="'min:8|lowercase|uppercase|numberOrSpecial'"
          id="password-input"
          ref="password"
          :disabled="saving"
          :class="{ 'is-invalid' : errors.has('password') || apiErrors.password.length}"
          class="form-control"
          data-vv-delay="0"
          type="password"
          name="password"
          placeholder="Password"
          @input="setPassword"/>
        <validation-errors :validation-errors="[errors.first('password')]"/>
        <validation-errors v-if="!errors.has('password')" :validation-errors="apiErrors.password"/>
      </b-form-group>

      <b-form-group>
        <label for="password-confirm">Confirm Password</label>
        <input
          v-validate ="{ rules: { required: confirmationIsRequired, confirmed: [ 'password' ] }}"
          id="password-confirm"
          :disabled="saving"
          :class="{ 'is-invalid' : errors.has('password-confirm') }"
          class="form-control"
          data-vv-delay="0"
          type="password"
          name="password-confirm"
          data-vv-as="password"
          placeholder="Confirm Password"/>
        <validation-errors :validation-errors="[errors.first('password-confirm')]"/>
      </b-form-group>

      <b-tooltip target="password-input" triggers="focus" placement="right">
        <password-rules/>
      </b-tooltip>

      <b-form-group class="form-buttons">
        <b-button
          :disabled="saving"
          variant="secondary"
          @click="$router.push('/')">
          Cancel
        </b-button>
        <b-button
          :disabled="disabled"
          type="submit"
          variant="primary">
          Confirm
          <span v-if="saving"><i class="fas fa-spinner fa-spin"></i></span>
        </b-button>
      </b-form-group>

      <form-success :success="success" class="form-alert">Profile Updated!</form-success>
    </b-form>
  </form-wrapper>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import formFail from '../../common/form/form-fail'
import formWrapper from '../../common/form/form-wrapper'
import passwordRules from '../../common/form/password-rules'
import validationErrors from '../../common/form/validation-errors'
import formSuccess from '../../common/form/form-success'

export default {
  components: {
    formFail,
    formWrapper,
    passwordRules,
    validationErrors,
    formSuccess
  },
  computed: {
    ...mapState('client/forms/profile', [
      'apiErrors',
      'success',
      'fields',
      'saving'
    ]),
    ...mapState('client', {
      client: 'data'
    }),
    confirmationIsRequired () {
      if (this.fields.password === null || this.fields.password === '') {
        return false
      }

      return true
    },
    disabled () {
      return this.errors.any() || this.saving
    }
  },
  created() {
    this.reset()
  },
  methods: {
    ...mapActions({
      updateMe: 'client/updateMe'
    }),
    reset () {
      this.$store.commit('client/forms/profile/resetState')
      this.errors.clear()
    },
    onSubmit (e) {
      e.preventDefault()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.updateMe()
        }
      })
    },
    setName (e) {
      this.$store.commit('client/forms/profile/setField', {
        field: 'name',
        value: e.target.value
      })
    },
    setEmail (e) {
      this.$store.commit('client/forms/profile/setField', {
        field: 'email',
        value: e.target.value
      })
    },
    setPassword (e) {
      this.$store.commit('client/forms/profile/setField', {
        field: 'password',
        value: e.target.value
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/profile/settings.vue